module.exports = __webpack_public_path__ + "img/inventory.ab8f08d4.png";